import english from "./en.json";
import norwegian from "./nb.json";
import finnish from "./fi.json";

export const resources = {
  en: { translation: english },
  nb: { translation: norwegian },
  fi: { translation: finnish },
} as const;

export type SupportedLanguage = keyof typeof resources;
export type TranslationKey =
  | keyof typeof english
  | keyof typeof norwegian
  | keyof typeof finnish;

export const supportedLanguages = Object.keys(resources) as SupportedLanguage[];
